import { makeStyles } from "@material-ui/core/styles"
import {
  DEFAULT_BOX_SHADOW,
  instance1,
  instance2,
  PRIMARY_BACKGROUND,
  TYPE_INSTANCE2,
} from "App/constants"
import { useSelectOption } from "App/hooks"
import { cantNullEmptyAndUndefined } from "App/utils/helpers"
import { isEmpty } from "lodash"
import { useEffect, useState } from "react"

export const urlGetLokasi = "/master-satu-sehat/location/list"
export const urlPostLokasi = "/master-satu-sehat/location/add"
export const urlUpdateLokasi = "/master-satu-sehat/location/update"
export const urlDeleteLokasi = "/master-satu-sehat/location/delete"

export const selectStatusLokasi = [
  {
    value: "",
    label: "Pilih Status Lokasi",
  },
  {
    value: "active",
    label: "Aktif",
  },
  {
    value: "suspended",
    label: "Diblokir",
  },
  {
    value: "inactive",
    label: "Tidak Aktif",
  },
]

export const selectModeLokasi = [
  {
    value: "",
    label: "Pilih Mode Lokasi",
  },
  {
    value: "instance",
    label: "Instance",
  },
  {
    value: "kind",
    label: "Kind",
  },
]

export const selectOperationalStatus = [
  {
    value: "",
    label: "Pilih Status Operasional",
  },
  {
    value: "C",
    label: "Tertutup",
  },
  {
    value: "H",
    label: "Pembenahan",
  },
  {
    value: "I",
    label: "Terpencil / Isolasi",
  },
  {
    value: "K",
    label: "Terkontaminasi",
  },
  {
    value: "O",
    label: "Sibuk",
  },
  {
    value: "U",
    label: "Kosong",
  },
]

export const selectHariAwal = [
  {
    value: "",
    label: "Pilih Hari Awal",
  },
  {
    value: "senin",
    label: "Senin",
  },
  {
    value: "selasa",
    label: "Selasa",
  },
  {
    value: "rabu",
    label: "Rabu",
  },
  {
    value: "kamis",
    label: "Kamis",
  },
  {
    value: "jumat",
    label: "Jum'at",
  },
  {
    value: "sabtu",
    label: "Sabtu",
  },
  {
    value: "minggu",
    label: "Minggu",
  },
]

export const selectHariAkhir = [
  {
    value: "",
    label: "Pilih Hari Akhir",
  },
  {
    value: "senin",
    label: "Senin",
  },
  {
    value: "selasa",
    label: "Selasa",
  },
  {
    value: "rabu",
    label: "Rabu",
  },
  {
    value: "kamis",
    label: "Kamis",
  },
  {
    value: "jumat",
    label: "Jum'at",
  },
  {
    value: "sabtu",
    label: "Sabtu",
  },
  {
    value: "minggu",
    label: "Minggu",
  },
]

export const selectJamAwal = [
  {
    value: "",
    label: "Pilih Jam Awal",
  },
  {
    value: "01:00",
    label: "01:00",
  },
  {
    value: "02:00",
    label: "02:00",
  },
  {
    value: "03:00",
    label: "03:00",
  },
  {
    value: "04:00",
    label: "04:00",
  },
  {
    value: "05:00",
    label: "05:00",
  },
  {
    value: "06:00",
    label: "06:00",
  },
  {
    value: "07:00",
    label: "07:00",
  },
  {
    value: "08:00",
    label: "08:00",
  },
  {
    value: "09:00",
    label: "09:00",
  },
  {
    value: "10:00",
    label: "10:00",
  },
  {
    value: "11:00",
    label: "11:00",
  },
  {
    value: "12:00",
    label: "12:00",
  },
  {
    value: "13:00",
    label: "13:00",
  },
  {
    value: "14:00",
    label: "14:00",
  },
  {
    value: "15:00",
    label: "15:00",
  },
  {
    value: "16:00",
    label: "16:00",
  },
  {
    value: "17:00",
    label: "17:00",
  },
  {
    value: "18:00",
    label: "18:00",
  },
  {
    value: "19:00",
    label: "19:00",
  },
  {
    value: "20:00",
    label: "20:00",
  },
  {
    value: "21:00",
    label: "21:00",
  },
  {
    value: "22:00",
    label: "22:00",
  },
  {
    value: "23:00",
    label: "23:00",
  },
  {
    value: "00:00",
    label: "00:00",
  },
]

export const selectJamAkhir = [
  {
    value: "",
    label: "Pilih Jam Awal",
  },
  {
    value: "01:00",
    label: "01:00",
  },
  {
    value: "02:00",
    label: "02:00",
  },
  {
    value: "03:00",
    label: "03:00",
  },
  {
    value: "04:00",
    label: "04:00",
  },
  {
    value: "05:00",
    label: "05:00",
  },
  {
    value: "06:00",
    label: "06:00",
  },
  {
    value: "07:00",
    label: "07:00",
  },
  {
    value: "08:00",
    label: "08:00",
  },
  {
    value: "09:00",
    label: "09:00",
  },
  {
    value: "10:00",
    label: "10:00",
  },
  {
    value: "11:00",
    label: "11:00",
  },
  {
    value: "12:00",
    label: "12:00",
  },
  {
    value: "13:00",
    label: "13:00",
  },
  {
    value: "14:00",
    label: "14:00",
  },
  {
    value: "15:00",
    label: "15:00",
  },
  {
    value: "16:00",
    label: "16:00",
  },
  {
    value: "17:00",
    label: "17:00",
  },
  {
    value: "18:00",
    label: "18:00",
  },
  {
    value: "19:00",
    label: "19:00",
  },
  {
    value: "20:00",
    label: "20:00",
  },
  {
    value: "21:00",
    label: "21:00",
  },
  {
    value: "22:00",
    label: "22:00",
  },
  {
    value: "23:00",
    label: "23:00",
  },
  {
    value: "00:00",
    label: "00:00",
  },
]

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    minWidth: "40px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "UID",
    align: "center",
    minWidth: "100px",
  },
  {
    id: "kode",
    disablePadding: true,
    label: "KODE",
    align: "center",
    minWidth: "100px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "center",
    minWidth: "120px",
  },
  {
    id: "description",
    disablePadding: false,
    label: "DESCRIPTION",
    align: "center",
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "center",
    minWidth: "100px",
  },
  {
    id: "mode",
    disablePadding: false,
    label: "MODE",
    align: "center",
  },

  {
    id: "type",
    disablePadding: false,
    label: "TIPE",
    align: "center",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]

export const headCellKontakLokasi = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    minWidth: "40px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    width: "10px",
    align: "center",
  },
  {
    id: "tipe",
    disablePadding: true,
    label: "Tipe Kontak",
    align: "center",
    minWidth: "100px",
  },
  {
    id: "value",
    disablePadding: false,
    label: "Input Kontak",
    align: "center",
    minWidth: "120px",
  },
]

export const headCellAlamatLokasi = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    minWidth: "40px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    width: "10px",
    align: "center",
  },
  {
    id: "tipe",
    disablePadding: true,
    label: "Tipe Lokasi",
    align: "center",
    minWidth: "100px",
  },
  {
    id: "value",
    disablePadding: false,
    label: "Keterangan",
    align: "center",
    minWidth: "120px",
  },
]

export const headCellPhysicalTypeLokasi = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    minWidth: "40px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    width: "10px",
    align: "center",
  },
  {
    id: "tipe",
    disablePadding: true,
    label: "Tipe Fisik Lokasi",
    align: "center",
    minWidth: "100px",
  },
  {
    id: "value",
    disablePadding: false,
    label: "Url Fisik Lokasi",
    align: "center",
    minWidth: "120px",
  },
]

export const selectTelecomLokasi = [
  {
    value: "",
    label: "Pilih Tipe Kontak",
  },
  {
    value: "phone",
    label: "Telepon",
  },
  {
    value: "fax",
    label: "FAX",
  },
  {
    value: "email",
    label: "Email",
  },
  {
    value: "pager",
    label: "Pager",
  },
  {
    value: "url",
    label: "Url",
  },
  {
    value: "sms",
    label: "SMS",
  },
  {
    value: "other",
    label: "Lainnya....",
  },
]

export const selectAlamatLokasi = [
  {
    value: "",
    label: "Pilih Alamat Lokasi",
  },
  {
    value: "postal",
    label: "Alamat Untuk Surat",
  },
  {
    value: "physical",
    label: "Alamat Yang Bisa Dikunjungi",
  },
  {
    value: "both",
    label: "Alamat Untuk Surat dan Yang Bisa Dikunjungi",
  },
]

export const selectTipeFisikLokasi = [
  {
    value: "",
    label: "Pilih Tipe Fisik Lokasi",
  },
  {
    value: "si",
    label: "Site",
  },
  {
    value: "bu",
    label: "Building",
  },
  {
    value: "wi",
    label: "Wing",
  },
  {
    value: "wa",
    label: "Ward",
  },
  {
    value: "lvl",
    label: "Level",
  },
  {
    value: "co",
    label: "Cooridor",
  },
  {
    value: "ro",
    label: "Room",
  },
  {
    value: "bd",
    label: "Bed",
  },
  {
    value: "ve",
    label: "Vehicle",
  },
  {
    value: "ho",
    label: "House",
  },
  {
    value: "ca",
    label: "Cabinet",
  },
  {
    value: "rd",
    label: "Road",
  },
  {
    value: "area",
    label: "Area",
  },
  {
    value: "jdn",
    label: "Jurisdiction",
  },
  {
    value: "vir",
    label: "Virtual",
  },
]

export const STYLE_MASTER_SATU_SEHAT_LOKASI = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
})

export const RESET_STATE_LOKASI = {
  id_location: "",
  parent_id_location: "",
  kode: "",
  name: "",
  description: "",
  status: "",
  mode: "",
  type: "",
  operationalStatus: "",
  telecom: [],
  physicalType: [],
  managingOrganization: [],
  id: "",
  partOf_parent_id: "",
  hoursOfOperation: [],
  availabilityExecptions: "",
  position: [],
  address: [],
  identifier: "",
  phone: "",
  fax: "",
  email: "",
  pager: "",
  url: "",
  other: "",
  pages: 1,
  limit: 10,
}

export const STATE_INFO = {
  id: "",
  id_location: "",
  parent_id_location: "",
  kode: "",
  name: "",
  description: "",
  managingOrganization: "",
  status: "",
  mode: "",
  operationalStatus: "",
  physicalTypeValue: "",
  physicalTypeLabel: "",
  poliklinikValue: "",
  poliklinikLabel: "",
  layananValue: "",
  layananLabel: "",
  jenisLokasiValue: "P",
  jenisLokasiLabel: "Poliklinik",
  isUpdate: false,
}

export const STATE_JADWAL = {
  available: false,
  hari_awal: "",
  hari_akhir: "",
  jam_awal: "",
  jam_akhir: "",
  availabilityExecptions: "",
}

export const STATE_KONTAK = {
  phone: "",
  email: "",
  url: "",
}

export const STATE_ALAMAT = {
  available: false,
  use: "",
  type: "",
  line: "",
  postalCode: "",
  country: "",
  url: "",
  province: "",
  province_name: "Pilih Provinsi",
  city: null,
  city_name: "Pilih Kota",
  district: "",
  district_name: "Pilih Kecamatan",
  sub_district: "",
  sub_district_name: "Pilih Kelurahan",
}

export const STATE_PHYSICAL_TYPE = {
  system: "",
  code: "",
  display: "",
}

export const deleteLokasi = async (id) => {
  try {
    const api = await instance1.post(urlDeleteLokasi, {
      id_location: id,
    })
    return {
      state: true,
      message: api.data.message,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const useCity = (id) => {
  const DEFAULT_OPTION = []
  const [state, setState] = useState(DEFAULT_OPTION)

  const get = async () => {
    try {
      const api = await instance2.get("/alamat/list_kota_byprop", {
        headers: {
          ms_locpropinsi_id: id,
        },
      })

      const res = api.data
      return res.body
    } catch (error) {
      return []
    }
  }

  useEffect(() => {
    ;(async () => {
      if (cantNullEmptyAndUndefined(id)) {
        const res = await get()
        if (res) {
          const data = []

          res.map((item) => {
            return data.push({
              value: `${item.id}`,
              label: `${item.name}`,
            })
          })

          setState(data)
        }
      }
    })()
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const useDistrict = (id) => {
  const DEFAULT_OPTION = []

  const [state, setState] = useState(DEFAULT_OPTION)

  const get = async () => {
    try {
      const api = await instance2.get("/alamat/list_kecamatan_bykota", {
        headers: {
          ms_lockota_id: id,
        },
      })
      const res = api.data
      return res.body
    } catch (error) {
      console.log(error?.response)
      return []
    }
  }

  useEffect(() => {
    ;(async () => {
      if (!isEmpty(id)) {
        const res = await get()
        if (res) {
          const data = []

          res.map((item) => {
            return data.push({
              value: `${item.id}`,
              label: `${item.name}`,
            })
          })

          setState(data)
        }
      }
    })()
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const useSubDistrict = (id) => {
  const DEFAULT_OPTION = []

  const [state, setState] = useState(DEFAULT_OPTION)

  const get = async () => {
    try {
      const api = await instance2.get("/alamat/list_kelurahan_bykec", {
        headers: {
          ms_lockecamatan_id: id,
        },
      })
      const res = api.data
      return res.body
    } catch (error) {
      return []
    }
  }

  useEffect(() => {
    ;(async () => {
      if (!isEmpty(id)) {
        const res = await get()
        if (res) {
          const data = []

          res.map((item) => {
            return data.push({
              value: `${item.id}`,
              label: `${item.name}`,
            })
          })

          setState(data)
        }
      }
    })()
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const getLokasi = async (formFilter, pages, limit) => {
  try {
    const api = await instance1.get(
      `${urlGetLokasi}?limit=${limit}&pages=${pages}&parent_id_location=${formFilter.parent_id_location}&name=${formFilter.name}`,
    )
    const res = api.data
    return {
      state: true,
      message: res.message,
      body: res.body,
      count: res.count,
      sisa: res.sisa,
      limit: res.limit,
      pages: res.pages,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const postLokasi = async (
  parent_id_location,
  kode,
  id_poliklinik,
  id_layanan,
  jenis_lokasi,
  name,
  description,
  status,
  mode,
  type,
  operationalStatus,
  telecom,
  physicalType,
  id,
  partOf_parent_id,
  hoursOfOperation,
  availabilityExecptions,
  position,
  address,
  identifier,
) => {
  try {
    const api = await instance1.post(`${urlPostLokasi}`, {
      parent_id_location: parent_id_location,
      kode: kode, //required
      id_poliklinik: id_poliklinik, //required
      id_layanan: id_layanan, //required
      jenis_lokasi: jenis_lokasi, //required
      name: name, // required
      description: description, //required
      status: status, //required
      mode: mode, // required
      type: type, // required
      operationalStatus: operationalStatus,
      telecom: telecom,
      physicalType: physicalType,
      id: id,
      partOf_parent_id: partOf_parent_id,
      hoursOfOperation: hoursOfOperation, //harus pake checklist, bisa required bisa enggak
      availabilityExecptions: availabilityExecptions, // satu paket sama hoursOfOperation
      position: position, //required
      address: address, // sama kayak hoursOfOperation dan availabilityExecptions
      identifier: identifier,
    })
    const res = api.data
    return {
      state: true,
      message: res.message,
      body: res.body,
      count: res.count,
      sisa: res.sisa,
      limit: res.limit,
      pages: res.pages,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const updateLokasi = async ({
  id_location,
  parent_id_location,
  kode,
  id_poliklinik,
  id_layanan,
  jenis_lokasi,
  name,
  description,
  status,
  mode,
  type,
  operationalStatus,
  telecom,
  physicalType,
  id,
  partOf_parent_id,
  hoursOfOperation,
  availabilityExecptions,
  position,
  address,
  identifier,
}) => {
  try {
    const api = await instance1.post(`${urlUpdateLokasi}`, {
      id_location: id_location,
      parent_id_location: parent_id_location,
      kode: kode,
      id_poliklinik: id_poliklinik,
      id_layanan: id_layanan,
      jenis_lokasi: jenis_lokasi,
      name: name,
      description: description,
      status: status,
      mode: mode,
      type: type,
      operationalStatus: operationalStatus,
      telecom: telecom,
      physicalType: physicalType,
      id: id,
      partOf_parent_id: partOf_parent_id,
      hoursOfOperation: hoursOfOperation,
      availabilityExecptions: availabilityExecptions,
      position: position,
      address: address,
      identifier: identifier,
    })
    const res = api.data
    return {
      state: true,
      message: res.message,
      body: res.body,
      count: res.count,
      sisa: res.sisa,
      limit: res.limit,
      pages: res.pages,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}
